var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-autocomplete", {
    staticClass: "inline-input",
    style: _vm.styleStr,
    attrs: {
      "fetch-suggestions": _vm.currencySearch,
      placeholder: "币种",
      size: _vm.sizeType,
    },
    on: { select: _vm.currencySelect },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return [_c("p", [_vm._v(_vm._s(scope.item.code))])]
        },
      },
    ]),
    model: {
      value: _vm.obj.currency,
      callback: function ($$v) {
        _vm.$set(_vm.obj, "currency", $$v)
      },
      expression: "obj.currency",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }